import type { documentNode, elementNode } from "rrweb-snapshot";
import { NodeType } from "rrweb-snapshot";
import { EventType } from "rrweb";
import type { eventWithTime, fullSnapshotEvent } from "@rrweb/types";

// TODO: take into account media conditions: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-media
// for example its best to filter out css files that are only used in print

const getHTMLElementNode = (event: fullSnapshotEvent): elementNode | undefined => {
  const { node } = event.data;
  if (node.type !== NodeType.Document) return undefined;
  const HTMLElement = node.childNodes.find(
    (element) => element.type === NodeType.Element && element.tagName === "html",
  ) as elementNode | undefined;

  return HTMLElement;
};

// function that loops through nested child nodes to find nodes with tagname link
const getLinksFromHTMLElementNode = (node: elementNode | documentNode): elementNode[] => {
  const links: elementNode[] = [];

  const { childNodes } = node;
  for (const childNode of childNodes) {
    if (
      childNode.type === NodeType.Element &&
      childNode.tagName === "link" &&
      childNode.attributes.href &&
      childNode.attributes.rel === "stylesheet"
    ) {
      links.push(childNode);
    }
    if ("childNodes" in childNode && childNode.childNodes.length > 0) {
      links.push(...getLinksFromHTMLElementNode(childNode));
    }
  }
  return links;
};

export const extractStylesheets = (events: eventWithTime[]): string[] => {
  const links = new Set();

  events.forEach((event) => {
    if (event.type !== EventType.FullSnapshot) return;
    const HTMLElement = getHTMLElementNode(event);
    if (!HTMLElement) return;

    getLinksFromHTMLElementNode(HTMLElement).forEach((link) => {
      if (typeof link.attributes.href !== "string") return;
      links.add(link.attributes.href);
    });
  });

  // flatten and remove undefined values
  return [...links] as string[];
};
export default extractStylesheets;
